import Icon from 'components/shared/icon';
import { useSettings } from 'contexts/SettingContext';
import {
  setStorageSelectedSalonNo,
  setStorageCustomerSalonName,
  setStorageCustomerSalonNo,
} from 'lib/shopify';
import styles from './salonSelector.module.scss';

// #742: the salon selector lives in the scrolling cart body (above the sticky
// subtotal) so it scrolls out of view, instead of sitting in the sticky footer
// (JW 2026-06-19).
const SalonSelector = ({ data, locale, onOpenSalonPanel }) => {
  const { hasSalonSelector, translations } = data;
  const { currentSalon, setCurrentSalon, setSalonManuallyDeleted } = useSettings();
  const { salonSelector } = translations || {};

  if (!hasSalonSelector) return null;

  // Same reset as salonsList.jsx removeSalon
  const removeSalon = () => {
    setStorageSelectedSalonNo(locale, '');
    setStorageCustomerSalonName(locale, '');
    setStorageCustomerSalonNo(locale, '');
    setCurrentSalon(null);
    setSalonManuallyDeleted(true);
  };

  // JW 2026-06-19: once a salon is selected, show only the chosen salon. The
  // "Selecteer…" prompt returns only after the salon is removed.
  if (currentSalon) {
    return (
      <div className={styles.selectedRow}>
        <p className={styles.selectedText}>
          {currentSalon.salonName}{' '}
          {currentSalon.salonLoyalty
            ? salonSelector?.ambassadorSalonSelectedText
            : salonSelector?.salonSelectedText}
        </p>
        <button
          type="button"
          className={styles.removeBtn}
          onClick={removeSalon}
          aria-label={salonSelector?.wontChooseSalon || 'Remove salon'}
        >
          <Icon type="trash" />
        </button>
      </div>
    );
  }

  return (
    <div className={styles.row}>
      <p className={styles.text}>{salonSelector?.salonChoiceDescription}</p>
      <button type="button" className={styles.button} onClick={onOpenSalonPanel}>
        {salonSelector?.chooseYourSalon}
      </button>
    </div>
  );
};

export default SalonSelector;
